export default [
    {
        path: '/stocktaking/whs-evaluation/:whs?/:filter?',
        name: 'whs_stocktaking_evaluation',
        meta: {
            title: 'Lager-Inventur',
            role: 'ROLE_STOCKTAKING_EVALUATION_SHOW',
        },
        component: () => import('@src/stocktaking/stocktaking-whs-evaluation'),
        props(route) {
            return { whs: route.params.whs !== '' ? route.params.whs : null };
        },
    },
    {
        path: '/stocktaking/bin/:id?',
        name: 'stocktaking_bin',
        meta: {
            title: 'Lagerfach-Inventur',
            role: 'ROLE_STOCKTAKING_EXECUTE',
        },
        component: () => import('@src/stocktaking/stocktaking-bin'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
    },
    {
        path: '/stocktaking/bin-evaluation',
        name: 'stocktaking_bin_evaluation',
        meta: {
            title: 'Inventur-Auswertung',
            role: 'ROLE_STOCKTAKING_EVALUATION_SHOW',
        },
        component: () => import('@src/stocktaking/stocktaking-bin-evaluation'),
    },
];
